import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const defaultConfig = {
  key: "key",
  value: "value",
  mode: null,
  rows: 200,
};
export interface SelectComposeInputConfig {
  key: string;
  value: string;
  mode?: string;
  placeholder?: string;
  rows: number;
}
export const selectComposeInputProps = buildProps({
  modelValue: {
    type: Object,
    required: true,
  },
  options: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  labelKey: {
    type: String,
    default: "text",
  },
  valueKey: {
    type: String,
    default: "id",
  },
  config: {
    type: Object,
  },
  leftWidth: {
    type: Number,
    default: 90,
  },
  rightWidth: {
    type: Number,
    default: 160,
  },
  noEmpty: {
    type: Boolean,
    default: false,
  },
  selectProps: {
    type: Object,
  },
} as const);
export type SelectComposeInputProps = ExtractPropTypes<
  typeof selectComposeInputProps
>;
